// extracted by mini-css-extract-plugin
export default {"root":"PrompthubNav_root__taeUJ","link":"PrompthubNav_link__ZZzb1","linkActive":"PrompthubNav_linkActive__5-dq5"};